import { Button } from "@mui/material";
import { NOTISTACK_ALERT_OPTIONS } from "constants/index";
import { setUnseenCounts } from "features/alerts/alertsSlice";
import { useAlerts, useAuth } from "features/store";
import { useGetUnseenAlertCountQuery } from "features/trading/accounts";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const UserAlertsWrapper = () => {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { trade_signal_count, position_mismatch_count } = useAlerts();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const unseenNotificationShownRef = useRef(false);

  const { data } = useGetUnseenAlertCountQuery(
    {
      user_id: user?.id,
      alert_type: "Position Mismatch",
    },
    {
      pollingInterval: 30_000,
      skip: !user,
    }
  );

  const enqueueAlertsNotification = useCallback((text: string) => {
    return enqueueSnackbar(text, {
      ...NOTISTACK_ALERT_OPTIONS,
      action: (key: number) => {
        return (
          <>
            <Button size="medium" sx={{ color: "#fff" }} onClick={() => {
              navigate("/alerts");
              closeSnackbar();
            }}>Check</Button>
            <Button size="medium" sx={{ color: "#fff" }} onClick={() => {
              closeSnackbar(key);
            }}>Dismiss</Button>
          </>
        );
      }
    } as any);
  }, [enqueueSnackbar, closeSnackbar, navigate, NOTISTACK_ALERT_OPTIONS]);

  useEffect(() => {
    const unseenNotificationShown = unseenNotificationShownRef.current;
    const prev_trade_signal_count = trade_signal_count;
    const prev_position_mismatch_count = position_mismatch_count;
    const cur_trade_signal_count = data?.trade_signal_count;
    const cur_position_mismatch_count = data?.position_mismatch_count;

    if (!unseenNotificationShown && prev_trade_signal_count === undefined && cur_trade_signal_count !== undefined) {
      enqueueAlertsNotification(`You have ${cur_trade_signal_count} unseen Trade Signal alert(s)!`);
      unseenNotificationShownRef.current = true;
    } else if (prev_trade_signal_count && cur_trade_signal_count && prev_trade_signal_count < cur_trade_signal_count) {
      enqueueAlertsNotification(`You've got ${cur_trade_signal_count - prev_trade_signal_count} new Trade Signal alert(s)!`);
    }

    if (!unseenNotificationShown && prev_position_mismatch_count === undefined && cur_position_mismatch_count !== undefined) {
      enqueueAlertsNotification(`You have ${cur_position_mismatch_count} unseen Position Mismatch alert(s)!`);
      unseenNotificationShownRef.current = true;
    } else if (prev_position_mismatch_count && cur_position_mismatch_count && prev_position_mismatch_count < cur_position_mismatch_count) {
      enqueueAlertsNotification(`You've got ${cur_position_mismatch_count - prev_position_mismatch_count} new Position Mismatch alert(s)!`);
    }

    if (cur_trade_signal_count !== undefined && cur_position_mismatch_count !== undefined) {
      dispatch(setUnseenCounts({ trade_signal_count: cur_trade_signal_count, position_mismatch_count: cur_position_mismatch_count }));
    }
  }, [unseenNotificationShownRef, data]);

  return <></>;
};

export default UserAlertsWrapper;
